import {Popover} from "@mantine/core";
import {useState} from "react";
import {ThreeDotsVertical} from "react-bootstrap-icons";
import {twMerge} from "tailwind-merge";
import {ItemBuilder} from "@vesta/global-common-typescript/components/itemBuilder";
import {
    copyWidgetScreenshotToClipboardWithId,
    copyWidgetScreenshotToClipboardWithRef,
    downloadWidgetScreenshotWithId,
    downloadWidgetScreenshotWithRef,
} from "~/modules/reports/utilities/reportUtilities";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {useAnankePreferences} from "@vesta/ananke/contexts/anankeClientContext";

export function ViewWidgetPopover({
    widgetRef,
    id,
    canvasHeight,
    canvasWidth,
    extraOptions,
}: {
    canvasHeight: string;
    canvasWidth: string;
    extraOptions?: Array<{
        id: Uuid;
        label: string;
        onClick: () => void;
    }>;
} & (
    | {
          widgetRef: React.MutableRefObject<HTMLDivElement | null>;
          id: null;
      }
    | {
          id: string;
          widgetRef: null;
      }
)) {
    const [opened, setIsOpened] = useState(false);
    const {theme} = useAnankePreferences();
    return (
        <Popover
            opened={opened}
            onChange={() => setIsOpened((prev) => !prev)}
            closeOnClickOutside={true}
        >
            <Popover.Target>
                <button
                    type="button"
                    onClick={() => setIsOpened((prev) => !prev)}
                    className={twMerge("transition duration-150 grid group-hover:visible", opened === true ? "" : "invisible")}
                >
                    <ThreeDotsVertical
                        id="should-hide-in-download"
                        className="h-4 w-4 cursor-pointer"
                    />
                </button>
            </Popover.Target>

            <Popover.Dropdown
                classNames={{
                    dropdown: "!bg-ds-surface",
                }}
            >
                <div className="grid grid-flow-row auto-rows-max gap-y-4">
                    <button
                        className="cursor-pointer w-full text-left transition duration-200 hover:gj-text-primary-lighter"
                        onClick={() => {
                            if (widgetRef == null && id != null) {
                                console.log("Downloading widget screenshot with id");
                                downloadWidgetScreenshotWithId(id, canvasHeight, canvasWidth, theme);
                            } else {
                                console.log("Downloading widget screenshot with ref");
                                downloadWidgetScreenshotWithRef(widgetRef, canvasHeight, canvasWidth, theme);
                            }
                        }}
                        type="button"
                    >
                        Download Screenshot
                    </button>

                    <button
                        className="cursor-pointer w-full text-left transition duration-200 hover:gj-text-primary-lighter"
                        onClick={() => {
                            if (widgetRef == null && id != null) {
                                copyWidgetScreenshotToClipboardWithId(id, canvasHeight, canvasWidth, theme);
                            } else {
                                copyWidgetScreenshotToClipboardWithRef(widgetRef, canvasHeight, canvasWidth, theme);
                            }
                        }}
                        type="button"
                    >
                        Copy Screenshot to Clipboard
                    </button>

                    {extraOptions === undefined ? null : (
                        <ItemBuilder
                            items={extraOptions}
                            itemBuilder={(item) => (
                                <button
                                    type="button"
                                    onClick={item.onClick}
                                    className="cursor-pointer w-full text-left transition duration-200 hover:gj-text-primary-lighter"
                                    key={item.id}
                                >
                                    {item.label}
                                </button>
                            )}
                        />
                    )}
                </div>
            </Popover.Dropdown>
        </Popover>
    );
}
